
interface Items {
  [proName:string]: string;
}

interface Date{
  [proName:string]: boolean;
}

interface DateFormat{
  [proName:string]: boolean;
}

// interface fieldName {
//   [propName: string]: string;
// }

export default class Dictionary {
  items: Items
  dateItems: Date
  showHours: DateFormat
  fieldName : any

  constructor (props?:any) {
    this.items = props || {
      name: '姓名',
    }

    this.dateItems = {
      requested_arrival_date: true,
      set_time: true,
      start_time: true,
      end_time: true,
      promised_delivery_date: true,
    }

    // true显示小时，false只显示日期
    this.showHours = {
      requested_arrival_date: false,
      set_time: true,
      start_time: false,
      end_time: false,
      promised_delivery_date: false,
    }
  }

  // 验证字典里是否有这个键
  has (key: string): boolean {
    return key in this.items
  }

  // 设置键值
  set (key: string, value: string): void {
    this.items[key] = value
  }

  // 删除键值
  remove (key: string): boolean {
    if (this.has(key)) {
      delete this.items[key]
      return true
    }
    return false
  }

  // 返回中文
  getValue (key: string): string | undefined {
    return this.has(key) ? this.items[key] : undefined
  }

  // 返回所有键(英文)
  getAllKeys (): string[] {
    const values = []
    for (const key in this.items) {
      if (this.has(key)) {
        values.push(key)
      }
    }
    return values
  }

  // 返回所有值(中文)
  getAllValues (): string[] {
    const values = []
    for (const key in this.items) {
      if (this.has(key)) {
        values.push(this.items[key])
      }
    }
    return values
  }

  // 返回所有键值
  getAllItems (): Items {
    return this.items
  }

  // 返回字典大小
  size (): number {
    return Object.keys(this.items).length
  }

  // 查询是否是日期，需不需要转格式
  isDate (key: string): boolean {
    return this.dateItems[key] ?? undefined
  }

  // 查询时间格式
  checkDateFormat (key: string): boolean {
    return this.showHours[key] ?? undefined
  }
}
